import { createContext } from "use-context-selector"

import { createProvider } from "domain/createProvider"
import { getDataGridInitState } from "domain/utils"

const initState = getDataGridInitState()

export const ProcessingFeesContext = createContext(initState)

export const ProcessingFeesProvider = createProvider(
  ProcessingFeesContext,
  initState
)
